// Dawn replaces the price / cart totals markup on variant and quantity changes, which removes the
// Affirm message along with it. affirmShopify.js only refreshes itself through jQuery, which this
// theme doesn't load, so re-run it once the new markup (and the new #affirm-price /
// #affirm-cart-total amount) is in place.
//
// Below the Affirm minimum, snippets/affirm-promo.liquid renders our own message instead, and
// affirmShopify.js never calls affirm.ui.refresh() — which is what makes its "Learn more"
// (.affirm-product-modal) open the Affirm modal. So refresh on load and after every re-render too.
(() => {
  // window.affirm and initializePromos are only defined once affirmShopify.js has run for a US/CA
  // storefront.
  const refreshAffirmUi = () => {
    if (!window.affirm) return;
    window.affirm.ui.ready(() => window.affirm.ui.refresh());
  };

  const refreshAffirmMessaging = () => {
    if (!window.affirm || typeof window.initializePromos !== 'function') return;
    window.initializePromos();
    refreshAffirmUi();
  };

  refreshAffirmUi();

  if (typeof subscribe !== 'function') return;

  subscribe(PUB_SUB_EVENTS.variantChange, refreshAffirmMessaging);
  subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAffirmMessaging);
})();
